import styled from "styled-components";

import { themes } from "@olist/design-system-tokens";

export const HeaderWrapper = styled.div`
  background-color: ${themes.olist.base.color.primary.base};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 16px 0;
  width: 100%;
`;

export const NavigationWrapper = styled.div`
  height: 64px;
  padding-top: 8px;
  width: 100%;
`;

export const WarningContainer = styled.div`
  background-color: ${themes.olist.base.color.notice.softer};
  color: #000;
  padding: 16px;
  text-align: center;
  width: 100%;
`;
